import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {Funcoes} from "../../funcoes";
import {Global} from "../../global";

import {FichasModel} from "../../fichas/fichas.model";
import {FichasService} from "../../fichas/fichas.service";
import {BasicValidators} from "../../shared/basic-validators";
import {ClientesFichasService} from "../clientes-fichas.service";
import {LoginService} from "../../login/login.service";

declare let $, swal: any;

@Component({
  selector: 'app-ficha-cliente',
  templateUrl: './ficha-cliente.component.html'
})
export class FichaClienteComponent implements OnInit {

  form: FormGroup;
  title: string;
  ficha: FichasModel = new FichasModel();
  listFotos = [];
  pressaoMin: number = null;
  pressaoMax: number = null;
  pressaoMedia: number = null;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private fichasService: FichasService,
    private clientesFichasService: ClientesFichasService,
    public loginService: LoginService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {

    this.form = formBuilder.group({
      id_ficha: [],
      id_cliente: ['', [
        Validators.required
      ]],
      id_importador: ['', [
        Validators.required
      ]],
      id_exportador: ['', [
        Validators.required
      ]],
      id_terminal: ['', [
        Validators.required
      ]],
      id_despachante: ['', [
        Validators.required
      ]],
      id_armador: ['', [
        Validators.required
      ]],
      id_pais_origem: ['', [
        Validators.required
      ]],
      id_viagem: ['', [
        Validators.required
      ]],
      id_transportador: ['', [
        Validators.required
      ]],
      id_unidade: ['', [
        Validators.required
      ]],
      referencia: [],
      fatura: [],
      container: ['', [
        BasicValidators.containerNumber
      ]],
      data_inspecao: [],
      conhecimento: [],
      id_mercadoria: [],
      marca: [],
      id_variedade: [],
      calibre: [],
      odor: [],
      id_embalagem: [],
      lote: [],
      brix: [],
      em_conformidade: [],
      embalagem_avariada: [],
      rotulo_divergente: [],
      carga_avancada: [],
      sem_rotulo: [],
      carga_tombada_porta: [],
      observacoes: [],
      conclusoes: [],
      setpoint: [],
      setpoint_off: [],
      airtemperature: [],
      airtemperature_off: [],
      ventilacao_bl: [],
      ventilacao_bl_fechado: [],
      temperatura_bl: [],
      avaria_interna_container: [],
      avaria_externa_container: [],
      lacre_origem: [],
      lacre_fechamento: [],
      fotos: []
    });
  }

  ngOnInit() {

    let id = this.route.params.subscribe(params => {
      let id = params['id_ficha'];

      this.title = this.func.traduzir('front.visualizarFicha');


      if (!id) {
        return;
      }

      this.clientesFichasService.getById(id, ["observacoes", "conclusoes", "defeitos", "fotos", "cliente", "importador", "exportador", "terminal", "pais_origem", "despachante", "armador", "viagem", "unidade", "transportador", "mercadoria", "embalagem", "variedade"])
        .subscribe(
          json => {
            this.title = this.func.traduzir('front.visualizarFicha') + ': ' + json.Payload[0].legenda;

            this.ficha = json.Payload[0];
            if (this.ficha && this.ficha.termografos) {
              try {
                if (typeof this.ficha.termografos === 'string') {
                  this.ficha.termografos = JSON.parse(this.ficha.termografos);
                }
              } catch (e) {
                this.ficha.termografos = [];
              }
            } else if (this.ficha) {
              this.ficha.termografos = [];
            }
            this.calcularMinMaxMediaPressao();
            this.listFotos = json.Payload[0].fotos;

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  loadVenobox(){
    $('.venobox').venobox();
  }

  calcularMinMaxMediaPressao() {
    if (this.ficha && this.ficha.pressao_polpa) {
      let pressaoData = typeof this.ficha.pressao_polpa === 'string' ? JSON.parse(this.ficha.pressao_polpa) : this.ficha.pressao_polpa;
      if (Array.isArray(pressaoData) && pressaoData.length > 0) {
        let validValues = [];
        pressaoData.forEach(val => {
          if (val !== null && val !== undefined && val !== '') {
            let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
            if (!isNaN(valFloat) && isFinite(valFloat)) {
              validValues.push(valFloat);
            }
          }
        });
        if (validValues.length > 0) {
          this.pressaoMin = Math.min(...validValues);
          this.pressaoMax = Math.max(...validValues);
          let sum = validValues.reduce((a, b) => a + b, 0);
          this.pressaoMedia = sum / validValues.length;
        } else {
          this.pressaoMin = null;
          this.pressaoMax = null;
          this.pressaoMedia = null;
        }
      } else {
        this.pressaoMin = null;
        this.pressaoMax = null;
        this.pressaoMedia = null;
      }
    } else {
      this.pressaoMin = null;
      this.pressaoMax = null;
      this.pressaoMedia = null;
    }
  }

  formatTemp(val: number): string {
    if (val === null || isNaN(val)) return '***';
    return val.toFixed(2).replace('.', ',');
  }
}



// WEBPACK FOOTER //
// ./src/app/area-cliente/minhas-fichas/ficha-cliente.component.ts